import { motion } from "framer-motion";
import { Minus, Plus } from "lucide-react";
import { toast } from "sonner";
import { useCart } from "@/context/CartContext";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

export const FlavorCard = ({ category, name, i = 0, showCategory = false }) => {
  const { add, qtyOf, setQty } = useCart();
  const qty = qtyOf(category.name, name);
  const id = `${category.id}-${slug(name)}`;
  const k = `${category.name}::${name}`;

  const onAdd = () => {
    add(category.name, name, 1);
    toast.success("Added to your box", { description: `${category.name} — ${name}` });
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 14 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: Math.min(i * 0.03, 0.4) }}
      data-testid={`flavor-card-${id}`}
      className={`group flex items-center justify-between gap-4 rounded-2xl border bg-white px-5 py-4 transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-0.5 hover:shadow-[0_12px_30px_-18px_rgba(45,30,24,0.4)] ${
        qty ? "border-[#E11D48]" : "border-[#F0DDD3]"
      }`}
    >
      <div className="min-w-0">
        {showCategory && <p className="f-mono mb-1 text-[11px] uppercase tracking-[0.18em] text-rose">{category.name}</p>}
        <p className="text-[15px] font-medium leading-snug text-cacao">{name}</p>
      </div>
      {qty ? (
        <div className="flex shrink-0 items-center gap-1 rounded-full bg-[#2D1E18] p-1 text-white">
          <button onClick={() => setQty(k, qty - 1)} data-testid={`item-qty-decrease-${id}`} className="grid h-8 w-8 place-items-center rounded-full hover:bg-white/15" aria-label="Decrease">
            <Minus className="h-3.5 w-3.5" />
          </button>
          <span className="w-6 text-center text-sm font-semibold" data-testid={`item-qty-${id}`}>{qty}</span>
          <button onClick={() => setQty(k, qty + 1)} data-testid={`item-qty-increase-${id}`} className="grid h-8 w-8 place-items-center rounded-full hover:bg-white/15" aria-label="Increase">
            <Plus className="h-3.5 w-3.5" />
          </button>
        </div>
      ) : (
        <motion.button
          whileTap={{ scale: 0.9 }}
          onClick={onAdd}
          data-testid={`item-add-button-${id}`}
          className="flex shrink-0 items-center gap-1.5 rounded-full border border-[#2D1E18]/15 px-4 py-2 text-sm font-semibold text-cacao transition-colors duration-300 group-hover:border-[#E11D48] group-hover:bg-[#E11D48] group-hover:text-white"
        >
          <Plus className="h-3.5 w-3.5" /> Add
        </motion.button>
      )}
    </motion.div>
  );
};
